<style scoped>

	iframe {
		height:1000px;
		width:1600px;
	}
</style>
<template>
  <div class="container my-5">
    <div class="row mb-3">
      <div class="col d-flex align-items-center">
        <h2 class="mb-0">Overview</h2>
      </div>
      <div class="col-auto">
        <button type="button" v-c-modal:createDrawer="{}" class="btn btn-light">
          <i class="fal fa-cog"></i> Project Settings
        </button>
      </div>
    </div>

    <div v-if="$can('read sales')" class="row">
      <div class="col-md-6 col-xl mb-4">
        <div class="card card-widget">
          <div class="card-body">
            <h3 class="widget-title">Delivery Budget Remaining</h3>
            <p :class="{ lead: true, strong: true, 'text-danger': project.budget_remaining < 0 }">${{ project.budget_remaining | currency0 }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl mb-4">
        <div class="card card-widget">
          <div class="card-body">
            <h3 class="widget-title">Original Budget</h3>
            <p :class="{ lead: true, strong: true }">${{ project.client_budget | currency0 }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl mb-4">
        <div class="card card-widget">
          <div class="card-body">
            <h3 class="widget-title">Sold to date</h3>
            <p :class="{ lead: true, strong: true }">${{ project.sold_to_date | currency0 }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl mb-4">
        <div class="card card-widget">
          <div class="card-body">
            <h3 class="widget-title">License Fee</h3>
            <p :class="{ lead: true, strong: true }">${{ project.license_fee | currency0 }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl mb-4">
        <div class="card card-widget">
          <div class="card-body">
            <h3 class="widget-title">Margin</h3>
            <p :class="{ lead: true, strong: true }">${{ project.margin | currency0 }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col d-flex align-items-center">
        <h2 class="mb-0">Stages</h2>
      </div>
      <div class="col-auto">
        <button @click="createStage()" type="button" class="btn btn-primary">
          <i class="far fa-plus"></i> Stage
        </button>
      </div>
    </div>

    <ul class="list-data">
      <li class="data-heading d-none d-lg-block">
        <div class="row">
          <div class="col-lg-3"><p>Stage</p></div>
          <div class="col-lg-3"><p>Dates</p></div>
          <div class="col-lg-3"><p>Team</p></div>
          <div class="col-lg-1 text-end"><p>Cost</p></div>
          <div class="col-lg-2 text-end"><p>Status</p></div>
        </div>
      </li>
      <li :key="stage.id" v-for="stage in stages">
        <router-link tag="a" :to="{ name: stageRouteName(stage), params: { project_id: project.id, sprint_id: 'active', stage_id: stage.id }}">
          <div class="row">
            <div class="col-12 col-lg-3">
              <p class="strong">{{stage.stage.name}}</p>
            </div>
            <div class="col-6 col-lg-3">
              <p>
                <span class="data-label d-lg-none">Dates:</span>
                {{ stage.commenced | moment("DD MMM YYYY")}} - <span v-if="stage.completed">{{ stage.completed | moment("DD MMM YYYY")}}</span>
              </p>
            </div>
            <div class="col-6 col-lg-3">
              <ul class="project-members">
                <li v-if="stage.lead" class="lead">
                  <i class="fal fa-crown"></i>
                  <img :src="getAvatar(stage.lead.id)" :title="'Lead: '+stage.lead.name">
                </li>
                <li v-for="member in stage.members" :key="member.id">
                  <img :src="getAvatar(member.id)" :title="member.name">
                </li>
              </ul>
            </div>
            <div class="col-6 col-lg-1 justify-content-lg-end">
              <p class="text-lg-end">
                <span class="data-label d-lg-none">Cost:</span>
                ${{ stage.total_cost | currency0 }}
              </p>
            </div>
            <div class="col-6 col-lg-2 justify-content-lg-end">
              <span v-if="stage.status" class="status" :class="statusClass(stage.status.name)">{{stage.status.name}}</span>
            </div>
          </div><!-- /.row -->
        </router-link>
      </li>
    </ul>

    <a href="#" @click.prevent="confirmDelete" class="text-danger">Delete Project</a>

    <create-drawer ref="createDrawer" :prop-project="project" mode="create" />
    <create-stage-draw ref="createStageDraw" :prop-stage="stage"></create-stage-draw>
  </div>
</template>

<script>
    //http://stackoverflow.com/documentation/javascript/4742/same-origin-policy-cross-origin-communication/30128/safe-cross-origin-communication-with-messages#t=201705171403471400655
//<div id="iframe-wrapper" style="position: absolute; width: 100%; height: 100%; top: 0px; background-color: #c3c3c3; z-index: 1000; opacity: 0.4;"><i class="fa fa-sticky-note" style=" font-size: 24px; z-index: 1005; position: absolute; top: 100px; left: 100px; color: red;"></i></div>
	import { notify, http } from 'utils'
	import Datepicker from 'vuejs-datepicker'
	import Stage from './../../../models/stage.js'
  import { Selectize, LaddaButton } from 'components/form/input'
	import { mapState, mapGetters, mapActions } from 'vuex'
  import CreateStageDraw from './stage/EditDrawer'
  import CreateDrawer from 'components/projects/CreateDrawer'
  import Project from '@/models/project.js'

  export default {
    components: {
      LaddaButton,
      Datepicker,
			Selectize,
      CreateStageDraw,
      CreateDrawer
    },

    data: function () {
      return {
        edit: false,
        loading: false,
				users: [],
				stage: new Stage()
      }
    },

    mounted () {
			this.getStages()
    },

    computed: {
			...mapState('yodizproject', {project: 'single'}),
			...mapState('yodizproject/stages', {stages: 'list', stateStage: 'single'}),

      'api': function() {
        return process.env.VUE_APP_API_URL;
			},
			'archived': {
				get: function() {
					return this.project.archived_at ? 1 : 0
				},
				set: function(value) {
					if (value == 0) {
						this.project.archived_at = null;
					} else {
						this.project.archived_at = moment().format('YYYY-MM-DD')
					}
				}
			}
    },
    route: {
      data: function() {

      }
    },
    watch: {

    },
    methods: {
      ...mapActions('yodizproject', {getProject: 'getSingle'}),
      ...mapActions('yodizproject/stages', {getStages: 'getList', getStage: 'getSingle', setStage: 'setSingle'}),

      stageRouteName: function(stage) {
                return 'projects.stage'+stage.stage.id+'.overview'
      },

      statusClass(status) {
        if (status) {

          return {
            'status-mute': status == 'Pending',
            'status-primary': status == 'In Progress',
            'status-success': status == 'Complete'
          }
        }

      },

			getAvatar (id) {
                return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
			},

			async editStage(stageId) {
				await this.getStage(stageId)

				this.$refs.createStageDraw.open()
			},

			createStage() {
				this.setStage(new Stage())

				this.$refs.createStageDraw.open()
			},

      saveProject: function() {

        var that = this;
          this.loading = true;

          return client({path: '/projects/'+this.project.id, entity: this.project, method: 'PUT'}).then(
              function(response) {
                that.$emit('update:project', response.entity)
                that.edit = false
              },
              function(response) {

                  if (response.status.code == 422) {
                      var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                  } else {

                  }
              }

          )

        this.edit = false;
      },
      confirmDelete(projectId) {
          var that = this;

          this.$swal({
            title: 'Confirm Delete',
            html: 'Are you sure you want to permanently delete this project',
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Delete',
          }).then(function() {
              that.deleteProject(projectId);
          }, function() {

          });

      },

      deleteProject (projectId) {
        return http.delete(`/projects/${this.project.id}`).then((response) => {
          this.$router.push({ name: 'projects.index' })
        }).catch((error) => {
          if (error.response.status.code == 422) {
            var firstValidationIssue = error.response.entity[Object.keys(error.response.entity)[0]];

            notify.error(firstValidationIssue)
          } else {
            notify.error('Error deleting project')
          }
        })
      },
    }
  }
</script>
